import * as React from 'react';
import type { ColumnProvider } from '../../index';
import { getColumnRangeHorizontalLayout } from '../getColumnRangeHorizontalLayout';
import { getHours, getMilliseconds, getMinutes } from 'owa-datetime';
import { getPalette } from 'owa-theme';
import { observableNow, observableToday } from 'owa-observable-datetime';
import { observer } from 'mobx-react-lite';
import { SurfaceConstants } from 'owa-calendar-surface-core';
import convertLayoutPositionToFlexStyles from '../../utils/convertLayoutPositionToFlexStyles';
import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';

export default observer(function TimeMarkerBaseContent({
    columnProvider,
    className,
    zIndex,
    prefaceClassName,
    markerClassName,
}: {
    columnProvider: ColumnProvider;
    className: string;
    zIndex?: number;
    prefaceClassName?: string;
    markerClassName?: string;
}) {
    const columnIndex = columnProvider.getColumnIndex(observableToday());
    if (columnIndex < 0) {
        return null;
    }

    const wrapperStyle: React.CSSProperties = {
        top: timeMarkerTop(),
        zIndex,
    };

    const themeSymbols = getPalette();
    const prefaceStyle = {
        borderColor: prefaceClassName && themeSymbols.themePrimary,
        ...convertLayoutPositionToFlexStyles(
            getColumnRangeHorizontalLayout(0, columnIndex, columnProvider)
        ),
    };

    const markerLayout =
        !markerClassName &&
        convertLayoutPositionToFlexStyles(
            getColumnRangeHorizontalLayout(columnIndex, columnIndex + 1, columnProvider)
        );

    const markerStyle = {
        backgroundColor: themeSymbols.themePrimary,
        ...markerLayout,
    };

    return (
        <div className={className} style={wrapperStyle}>
            <div className={prefaceClassName} style={prefaceStyle} />
            <div className={markerClassName} style={markerStyle} />
        </div>
    );
});

function timeMarkerTop() {
    let now = observableNow();
    let milliseconds =
        getHours(now) * TimeConstants.MillisecondsIn1Hour +
        getMinutes(now) * TimeConstants.MillisecondsIn1Min +
        getMilliseconds(now);

    return milliseconds / (SurfaceConstants.HourRowHeight * TimeConstants.MillisecondsIn1Sec);
}
